import * as React from 'react';
import * as style from './swiper.module.scss';
import useMediaQuery from '@mui/material/useMediaQuery';

const TitleSwiper = ({ selectedSlideIndex, selectSlide, data }) => {
  const swiperEl = React.useRef();
  const isMobile = useMediaQuery('(max-width:767px)');
  React.useEffect(() => {
    if (swiperEl.current) {
      Object.assign(swiperEl.current, {
        slidesPerView: 1,
        //spaceBetween: isMobile ? 400 : 70,
        spaceBetween: 70,
        direction: 'vertical',
        initialSlide: selectedSlideIndex,
        centeredSlides: true,
        grabCursor: true,
        autoHeight: true,
        height: isMobile ? 60 : 100,
        freeMode: true,
        watchSlidesProgress: true,
        mousewheel: {
          forceToAxis: true,
        },
        effect: 'coverflow',
        coverflowEffect: {
          rotate: 0,
          stretch: 1,
          depth: isMobile ? 500 : 200,
          modifier: 1,
          slideShadows : false,
        },
        autoplay: {
          delay: 1000,
          pauseOnMouseEnter: true,
          disableOnInteraction: true,
          initialSlide: selectedSlideIndex,
        },
        speed: 1500
      });
      swiperEl.current.initialize();
    }
    swiperEl.current?.addEventListener('activeindexchange', () => {
      const newIndex = swiperEl.current?.swiper.activeIndex;
      if (typeof newIndex === 'number' && newIndex !== selectedSlideIndex) {
        selectSlide(newIndex);
      }
    });
    if (swiperEl.current?.swiper.activeIndex !== selectedSlideIndex) {
      swiperEl.current?.swiper.slideTo(selectedSlideIndex);
    }
  }, [selectedSlideIndex, selectSlide, isMobile]);

  return (
    <>
      <swiper-container ref={swiperEl} class={style.titleSwiper} init="false">
        {data.map((elem, index) => (
          <swiper-slide key={index}>
            <button
              className={style.titleSlide}
              onClick={() => {
                selectSlide(index);
              }}
            >
              <div
                style={{
                  width: '120px',
                  position: 'absolute',
                  top: isMobile ? '-5px' : '-10px',
                  left: '0',
                  height: isMobile ? '75px' : '120px',
                  backgroundImage: `url(${elem.image})`,
                  backgroundRepeat: 'no-repeat',
                  backgroundSize: isMobile ? '60%' : '100%'
                }}
              />
              {elem.title}
            </button>
          </swiper-slide>
        ))}
      </swiper-container>
    </>
  );
};
export default TitleSwiper;
